import { IconMinus16, IconPlus16 } from '@warp-ds/icons/react';
import { Button } from '@warp-ds/react';
import cn from 'classnames';
import { useState } from 'react';

import styles from './Description.module.css';

interface Props {
    description: string;
}

export const Description = ({ description }: Props) => {
    const longDescription: boolean = description?.length > 671;
    const [expanded, setExpanded] = useState(!longDescription);

    return (
        <div className="overflow-hidden mt-16">
            <div className="mb-0 relative">
                <div className="preserve-linebreaks" data-testid="adDescription">
                    <div
                        data-testid="value"
                        className={cn(styles.description, {
                            [styles['description--expanded']]: expanded,
                        })}
                        dangerouslySetInnerHTML={{ __html: description }}
                    />
                </div>
                <div className={expanded ? '' : 'read-more'}>
                    {longDescription && (
                        <Button link className="mt-8" onClick={() => setExpanded(!expanded)}>
                            {expanded ? <IconMinus16 className="inline-block mr-8" /> : <IconPlus16 className="inline-block mr-8" />}
                            <span className="align-text-top font-bold">{expanded ? 'Vis mindre' : 'Vis hele beskrivelsen'}</span>
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
};
